import { InjectionToken } from '@angular/core';

export const windowToken = new InjectionToken<Window>('window');
export const windowRef = window;
